// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1ydyb","errorLogs":"styles_errorLogs__3SbH3"};